function loading(container = null) {

	if (!container) {
		container = document.body;
	}

	container.classList.add('loading');
}

function stopLoading(container = null) {
	if (!container) {
		container = document.body;
	}
	container.classList.remove('loading');
}

export {
	loading,
	stopLoading
}
